// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.packages-stepper{border-radius:12px!important}.packages-stepper .q-stepper__header{border-bottom:1px solid rgba(0,0,0,.06)}.packages-stepper .q-stepper__step-content{padding:24px 16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
